import { normalInverse } from '../math/norml-inverse';
import { VariableValueSimulator } from '@iotize/virtual-tap';

export interface GeometicBrownianMotionSimulatorOptions {
  currentValue: number;
  mean: number;
  standardDeviation: number;
  min?: number;
  max?: number;
}

function geometicBrownianMotion({
  currentValue,
  mean,
  standardDeviation,
}: GeometicBrownianMotionSimulatorOptions) {
  const drift = mean - (standardDeviation * standardDeviation) / 2;
  const randomShock = standardDeviation * normalInverse(Math.random());
  return currentValue * Math.exp(drift + randomShock);
}

export class GeometicBrownianMotionSimulator implements VariableValueSimulator {
  constructor(private _prev: GeometicBrownianMotionSimulatorOptions) {}

  generateNextValue(): number {
    let newValue = geometicBrownianMotion(this._prev);
    if (this._prev.min !== undefined && newValue < this._prev.min) {
      newValue = this._prev.min;
    }
    if (this._prev.max !== undefined && newValue > this._prev.max) {
      newValue = this._prev.max;
    }
    this._prev.currentValue = newValue;
    return newValue;
  }
}
